import PlannerMap from 'core/js/pages/planner/direction-internal-result/_planner-map'
import {aggregateStopsByZoom} from '../../../lib/map/aggregate-stops-by-zoom'

// Extiende el show del core y fuerza el layout extendido para VL
export default {
  extends: PlannerMap,
  template: PlannerMap.template,

  data() {
    return {
      currentZoom: 17
    }
  },

  props: {
    ...PlannerMap.props,
    useExtendedLayout: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    mapFilteredStops() {
      return aggregateStopsByZoom(this.filteredStops, {
        map: this.map,
        zoom: this.currentZoom,
        selectedStop: this.selectedStopId ? {id: this.selectedStopId} : null
      })
    }
  },

  watch: {
    map: {
      immediate: true,
      handler(newMap, oldMap) {
        if (oldMap?.off) oldMap.off('zoomend', this.updateCurrentZoom)
        if (!newMap?.on) return

        this.currentZoom = newMap.getZoom()
        newMap.on('zoomend', this.updateCurrentZoom)
      }
    }
  },

  beforeDestroy() {
    if (this.map?.off) this.map.off('zoomend', this.updateCurrentZoom)
  },

  methods: {
    updateCurrentZoom(event) {
      const map = event?.target || this.map
      if (map?.getZoom) this.currentZoom = map.getZoom()
    }
  }
}
